import { useState, useEffect } from 'react';
import './SmsManagement.css';
import { useSearchParams } from 'react-router-dom';
import SmsContacts from './components/SmsContacts';
import SmsHistory from './components/SmsHistory';
/**
 * SMS 발령 관리 및 이력 페이지
 * 시스템 관리자만 접근 가능
 */
function SmsManagement() {
  const [activeTab, setActiveTab] = useState('contacts'); // 'contacts' or 'history'
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    setActiveTab(searchParams.get('t') || 'contacts');
  }, [searchParams]);
  return (
    <div className="sms-management-page-container page-container">
      <div className="tabs grid-cols-2 w-quarter">
        <button className={`tab ${activeTab === 'contacts' ? 'active' : ''}`} onClick={() => {
          const current = Object.fromEntries(searchParams.entries());
          setSearchParams({ ...current, t: 'contacts' });
        }}>연락처</button>
        <button className={`tab ${activeTab === 'history' ? 'active' : ''}`} onClick={() => {
          const current = Object.fromEntries(searchParams.entries());
          setSearchParams({ ...current, t: 'history' });
        }}>이력</button>
      </div>
      <div className="sms-management-content">
        {activeTab === 'contacts' && (
          <SmsContacts />
        )}
        {activeTab === 'history' && (
          <SmsHistory />
        )}
      </div>
    </div>
  );
}

export default SmsManagement;
